import api from "./core";

const basePath = "api/{{serverSegment}}/Versions";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  updateDependencies(id, data) {
    return api.patch(`${basePath}/${id}/dependencies`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(formId) {
    return api.post(`${basePath}/${formId}`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
